/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/



// RADIANCE COLLECTIVE 
// DRAWER NOTIFICATION WHEN ADD TO CART

(function() {
  const popdown = document.querySelector('[data-product-add-popdown-wrapper]');
  if (!popdown) return;

  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.target.classList.contains('is-visible')) {
        mutation.target.classList.remove('is-visible');
        document.querySelector('[data-drawer-toggle="drawer-cart"]').click();
      }
    });
  });

  observer.observe(popdown, { attributes: true, attributeFilter: ['class'] });
})();

// END DRAWER NOTIFICATION WHEN ADD TO CART